import type { RuntimeConfig } from 'venn-api';

// Production rather than local: a deployment whose config.js failed to load must behave as the strictest
// environment (no debug tooling, no session replay), never as a developer machine.
const FALLBACK_CONFIG: RuntimeConfig = { env: 'production', domain: '' };

export const getRuntimeConfig = (): RuntimeConfig =>
  (typeof window === 'undefined' ? undefined : window.__APP_CONFIG__) ?? FALLBACK_CONFIG;
